import { forwardRef, useImperativeHandle, useState } from "react";
import MDBox from "components/Basics/MDBox";

import shopInterface from "./ShopInterface";

const INTERFACES = {
	shopInterface
};

export const INTERFACE_ACTION = {
	INSERT: "insert",
	UPDATE: "update",
	DELETE: "delete"
};

/**
 * Controller component to manage different interfaces based on actions
 */
const InterfaceController = forwardRef((props, ref) => {
	const [currentDisplay, setCurrentDisplay] = useState({
		open: false,
		action: null
	});

	const isOpen = action => {
		return currentDisplay.open && currentDisplay.action === action;
	};

	// Expose methods to the parent component via ref
	useImperativeHandle(ref, () => ({
		display: (action, values) => {
			setCurrentDisplay({
				open: true,
				action,
				values
			});
		}
	}));

	return (
		<MDBox>
			{/* Special actions */}
			{Object.entries(INTERFACES).map(([actionKey, ActionComponent]) => (
				<ActionComponent
					key={actionKey}
					{...currentDisplay}
					resource={props.resource}
					refreshChart={props.refreshChart}
					open={isOpen(actionKey)}
					onClose={() => setCurrentDisplay({ open: false, action: null })}
				/>
			))}
		</MDBox>
	);
});

export default InterfaceController;
